import React from 'react';

function Mobile() {
  return <div>Mobile view is not yet implemented.</div>;
}

export default Mobile;

